import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import UserImageLogo_bg from "../../images/UserImageLogo_bg.jpg";
import UserLogo_Tablelist from "../../images/UserLogo_Tablelist.png";
import DropDown from "../CommonControlls/DropdownRendrer";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
		UpdateProfileChanges: (User) => {
			dispatch({ type: "UpdateProfileChanges", payload: User });
		},
	};
};

class UserProfile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isImageUpdated: false,
			isMicroscope: false,

			//Roles
			RolesLoader: false,
			Roleslist: [],
			RoleId: props.UserAuthentication.UserInfo?.roleId,

			Provincelist: [],
			ProvinceId: 0,

			Tehsillist: [],
			TehsilId: 0,
			FilteredTehsillist: [],

			Districtlist: [],
			DistrictId: 0,
			FilteredDistrictlist: [],
		};
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState(
			{
				[fieldId]: value,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (fieldId === "ProvinceId") {
					this.FilterDistricts(value);
				}
				if (fieldId === "DistrictId") {
					this.FilterTehsils(value);
				}
			}
		);
	};
	FilterDistricts = (value) => {
		// filter ditrict list
		var TempArr = this.state.Districtlist;
		var filteredDistrictList = TempArr.filter(
			(item) => item.provinceId === value
		);

		this.setState({
			FilteredDistrictlist: filteredDistrictList,
		});
	};
	FilterTehsils = (value) => {
		// filter Tehsil list
		var TempArr = this.state.Tehsillist;
		var filteredTehsilList = TempArr.filter(
			(item) => item.districtId === value
		);

		this.setState({
			FilteredTehsillist: filteredTehsilList,
		});
	};
	render() {
		return (
			<div>
				<MainLayout />
				<div id="right-panel" class="right-panel">
					<Topmenu PageTitle="Profile Settings" isShowAddBtn={false} />
					<div class="content col-md-12">
						{/* <div class="PageHeader_Container">
                <h2>Profile Settings</h2>
            </div> */}

						<div class="card col-md-10 col-lg-10">
							<div class="card-body row">
								<div
									class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
									style={{
										borderBottom: "1px solid #ced4da",
										paddingBottom: "25px",
										marginBottom: "20px",
									}}
								>
									<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center">
										<div
											class=""
											style={{ maxWidth: "300px", position: "relative" }}
										>
											<img
												class="user-avatar rounded-circle"
												style={{ height: "100px", width: "100px" }}
												src={
													this.props.UserAuthentication?.UserInfo
														?.imageURLBase64 == "" ||
													this.props.UserAuthentication?.UserInfo
														?.imageURLBase64 == null
														? UserLogo_Tablelist
														: this.props.UserAuthentication?.UserInfo
																?.imageURLBase64
												}
												id="Upload_ImageDropZone"
											/>
											<span
												class="UserProfileImage_btn"
												onClick={() => {
													$("#UploadImgBtn").click();
												}}
											>
												<i class="fa fa-camera" aria-hidden="true"></i>
											</span>
											<input type="hidden" id="changedimagekey" />
											<input
												name="file"
												// type="button"
												class="col-md-12"
												style={{
													paddingLeft: "0px",
													fontSize: "17px",
													cursor: "pointer",
													display: "none",
												}}
												accept="image/gif,image/jpeg,image/png"
												type="file"
												id="UploadImgBtn"
											/>
										</div>
									</div>

									<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div class="UserDetailName">
											{this.props.UserAuthentication?.UserInfo?.roleName}
										</div>
										<div class="UserDetail_SubHeading">
											{this.props.UserAuthentication?.UserInfo?.roleId == 1 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 4 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 5 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 8
												? ""
												: this.props.UserAuthentication?.UserInfo?.roleId == 3
												? this.props.UserAuthentication?.UserInfo?.xpertSiteName
												: this.props.UserAuthentication?.UserInfo?.roleId ==
														6 ||
												  this.props.UserAuthentication?.UserInfo?.roleId == 7
												? this.props.UserAuthentication?.UserInfo?.hcfName
												: ""}
										</div>
										<div class="UserDetail_SubHeading">
											{this.props.UserAuthentication?.UserInfo?.roleId == 1 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 4 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 5 ||
											this.props.UserAuthentication?.UserInfo?.roleId == 8
												? ""
												: this.props.UserAuthentication?.UserInfo?.roleId == 3
												? this.props.UserAuthentication?.UserInfo
														?.xpertSiteAddress
												: this.props.UserAuthentication?.UserInfo?.roleId ==
														6 ||
												  this.props.UserAuthentication?.UserInfo?.roleId == 7
												? this.props.UserAuthentication?.UserInfo?.hcfAddress
												: ""}
										</div>
									</div>
								</div>

								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<form onSubmit={this.SubmitForm} novalidate>
										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">
													<span style={{ color: "red" }}> </span>User Name
												</label>
												<input
													autocomplete="off"
													type="text"
													placeholder="Enter user name"
													class="form-control"
													id="Profile_Name"
													required
													defaultValue={
														this.props.UserAuthentication.UserInfo.name
													}
												/>
											</div>
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">
													<span style={{ color: "red" }}> </span>Cnic
												</label>
												<input
													autocomplete="off"
													type="text"
													placeholder="Enter user Cnic"
													defaultValue={
														this.props.UserAuthentication.UserInfo.cnic
													}
													class="form-control"
													id="Profile_Cnic"
													required
												/>
											</div>
										</div>
										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">
													<span style={{ color: "red" }}></span>Phone
												</label>
												<input
													autocomplete="off"
													pattern="[0][0-9]{10}"
													type="text"
													placeholder="Enter user phone - 03123456789"
													class="form-control"
													defaultValue={
														this.props.UserAuthentication.UserInfo.contact
													}
													id="Profile_Phone"
													required
												/>
											</div>
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">
													<span style={{ color: "red" }}></span>Bank Name
												</label>
												<input
													autocomplete="off"
													type="text"
													placeholder="Enter user bank name"
													class="form-control"
													defaultValue={
														this.props.UserAuthentication.UserInfo.bankName
													}
													id="Profile_BankName"
													required
												/>
											</div>
										</div>
										<div
											class="formInput_Container col-md-6 col-lg-6 col-6"
											hidden={
												this.props.UserAuthentication.UserInfo.roleId == 4
													? false
													: true
											}
										>
											<label for="">
												<span style={{ color: "red" }}>* </span>Vehicle Number
											</label>
											<input
												autocomplete="off"
												type="text"
												class="form-control"
												id="Profile_VehicleNumber"
												defaultValue={
													this.props.UserAuthentication.UserInfo.vehicleNumber
												}
												placeholder="Enter user vehicle number"
												required={
													this.props.UserAuthentication.UserInfo.roleId == 4
														? true
														: false
												}
											/>
										</div>

										<div
											class="formInput_Container col-md-6 col-lg-6 col-6"
											hidden={
												this.props.UserAuthentication.UserInfo.roleId == 4
													? false
													: true
											}
										>
											<label for="">
												<span style={{ color: "red" }}>* </span>Vehicle Model
											</label>
											<input
												autocomplete="off"
												type="text"
												class="form-control"
												id="Profile_VehicleModel"
												defaultValue={
													this.props.UserAuthentication.UserInfo.vehicleModel
												}
												placeholder="Enter user vehicle model"
												required={
													this.props.UserAuthentication.UserInfo.roleId == 4
														? true
														: false
												}
											/>
										</div>

										<div
											class="formInput_Container col-md-6 col-lg-6 col-6"
											hidden={
												this.props.UserAuthentication.UserInfo.roleId == 4
													? false
													: true
											}
										>
											<label for="">Account Number</label>
											<input
												autocomplete="off"
												type="text"
												class="form-control"
												id="Profile_AccountNumber"
												defaultValue={
													this.props.UserAuthentication.UserInfo.accountNumber
												}
												placeholder="Enter rider Account Number"
											/>
										</div>
										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">Email</label>
												<input
													autocomplete="off"
													type="email"
													class="form-control"
													placeholder="Enter user email"
													id="Profile_Email"
													defaultValue={
														this.props.UserAuthentication.UserInfo.email
													}
												/>
											</div>
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">
													<span style={{ color: "red" }}></span>Account Number
												</label>
												<input
													autocomplete="off"
													type="number"
													class="form-control"
													defaultValue={
														this.props.UserAuthentication.UserInfo.accountNumber
													}
													placeholder="Enter user Bank Number"
													id="Profile_BankNumber"
												/>
											</div>
										</div>

										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">
												<label for="">Address</label>
												<textarea
													class="form-control"
													id="Profile_Address"
													placeholder="Enter user address"
													rows="3"
													defaultValue={
														this.props.UserAuthentication.UserInfo.address
													}
												></textarea>
											</div>
											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">
													<span style={{ color: "red" }}>* </span>Role
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="RoleId"
													options={this.state.Roleslist}
													val={this.state.RoleId}
													addPlaceholder=""
													loading={this.state.RolesLoader}
													searchBy="roleName"
													labelField="roleName"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>
										</div>
										<div className="row">
											<div className="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<label htmlFor="">Province</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="ProvinceId"
													options={this.state.Provincelist}
													val={this.state.ProvinceId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.ProvinceLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div className="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<label htmlFor="">District</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="DistrictId"
													options={this.state.FilteredDistrictlist}
													val={this.state.DistrictId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.DistrictLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div className="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<label htmlFor="">Tehsil</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="TehsilId"
													options={this.state.FilteredTehsillist}
													val={this.state.TehsilId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.TehsilLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>
										</div>
										{/*<div class="row">*/}
										{/*    <div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">*/}
										{/*        <label for=""><span style={{color: "red"}}> </span>District</label>*/}
										{/*        <input autocomplete="off" type="text" class="form-control"*/}
										{/*            placeholder="Enter user District" id="Profile_District"/>*/}
										{/*    </div>*/}
										{/*    <div class="formInput_Container col-lg-6 col-md-6 col-sm-6 col-xs-6">*/}
										{/*        <label for=""><span style={{color: "red"}}> </span>Tehsil</label>*/}
										{/*        <input autocomplete="off" type="text" class="form-control"*/}
										{/*            placeholder="Enter user Tehsil" id="Profile_Tehsil"/>*/}
										{/*    </div>*/}
										{/*</div>*/}
										{/*<div className="w-full">*/}
										{/*    Microscope*/}
										{/*    <label className="switch">*/}
										{/*        <input type="checkbox" checked={this.state.isMicroscope} onChange={this.AddRemoveMicroscope}/>*/}
										{/*        <span className="slider round"></span>*/}
										{/*    </label>*/}
										{/*</div>*/}

										<div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
											<button
												type="submit"
												id="Form_SaveBtn"
												class="btn btn_style1"
											>
												Save
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>

						{/* <div class="card col-md-4 col-lg-4" style={{padding:"10px",background:"none",boxShadow:"none"}}>
                <div class="card-body">
                    <label for="">Image</label>
                    <div className="ImagePlacement_Container" style={{marginTop:"35px"}}>
                        <img class="dopzone-logo" src={this.props.UserAuthentication?.UserInfo?.imageURLBase64==""?"":this.props.UserAuthentication?.UserInfo?.imageURLBase64} id="Upload_ImageDropZone" />
                        <span class="updateimage-Btn" onClick={()=>{$("#UploadImgBtn").click()}}><i class="fa fa-plus" aria-hidden="true"></i></span>
                        <input type="hidden" id="changedimagekey"/>
                        <input name="file" type="button" class="col-md-12" style={{ paddingLeft:"0px",fontSize: "17px", cursor: "pointer",display:"none"}} accept="image/gif,image/jpeg,image/png" type="file" id="UploadImgBtn" />
                    </div>
                </div>
            </div> */}
					</div>
				</div>
			</div>
		);
	}

	componentDidMount() {
		// if(this.props.UserAuthentication?.UserInfo?.imageURLBase64=="")
		// {
		//     $("#Upload_ImageDropZone").hide()
		// }
		this.setState({
			ProvinceId: this.props.UserAuthentication.UserInfo.addressProvinceId,
			DistrictId: this.props.UserAuthentication.UserInfo.addressDistrictId,
			TehsilId: this.props.UserAuthentication.UserInfo.addressTehsilId,
		});
		this.GetPageConfigData();
		$("#UploadImgBtn").change((e) => {
			this.setState({
				isImageUpdated: true,
			});
			for (var i = 0; i < e.originalEvent.srcElement.files.length; i++) {
				var file = e.originalEvent.srcElement.files[i];
				var reader = new FileReader();
				reader.onloadend = function () {
					$("#Upload_ImageDropZone").attr("src", reader.result);
					// $("#Upload_ImageDropZone").show()
				};
				reader.readAsDataURL(file);
			}
		});
		$(".UserTopMenu").removeClass("ActiveUserOption");
		$("#UserTopMenu_settings").addClass("ActiveUserOption");

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/HCF/SelectActiveInActiveStatus",
			{ userId: this.props.UserAuthentication.UserInfo.id },
			(resp) => {
				if (resp.status) {
				}
			}
		);
	}

	AddRemoveMicroscope = ({ target: { checked } }) => {
		const Parameters = {
			user_id: this.props.UserAuthentication.UserInfo.id,
			is_Microscope: checked,
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.AddRemove_Microscope,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						isMicroscope: checked,
					});
				}
			}
		);
	};
	GetPageConfigData = () => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();

		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectTehsil(() => {
			d3.resolve();
		});
		this.SelectRoles(() => {
			d4.resolve();
		});

		$.when(d1, d2, d3, d4).done(() => {
			this.props.ShowLoader({ Isloading: false });
		});
	};

	SelectRoles = (Callback) => {
		this.setState({ RolesLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Role,
			{},
			(data) => {
				this.setState({
					RolesLoader: false,
					Roleslist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ RolesLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: data.data.sort(Common.compare),
					FilteredDistrictlist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectTehsil = (Callback) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(data) => {
				this.setState({
					TehsilLoader: false,
					Tehsillist: data.data.sort(Common.compare),
					FilteredTehsillist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};

	SubmitForm = (e) => {
		e.preventDefault();
		Common.encodeImgtoBase64("UploadImgBtn", (imageURLBase64) => {
			this.props.ShowLoader({ Isloading: true });
			var formData = new FormData();
			// if(this.state.isImageUpdated)
			// {
			//     var ins = $('#UploadImgBtn')[0].files.length;
			//     for (var x = 0; x < ins; x++) {
			//       formData.append("files", $('#UploadImgBtn')[0].files[x])
			//     }
			// }
			// else
			// {
			//     formData.append('files',null);
			// }
			formData.append("name", $("#Profile_Name").val());
			formData.append("contact", $("#Profile_Phone").val());
			formData.append("email", $("#Profile_Email").val());
			formData.append("address", $("#Profile_Address").val());
			formData.append("vehicleNumber", $("#Profile_VehicleNumber").val());
			formData.append("vehicleModel", $("#Profile_VehicleModel").val());
			formData.append(
				"imageURLBase64",
				this.state.isImageUpdated
					? imageURLBase64
					: this.props.UserAuthentication?.UserInfo?.imageURLBase64
			);
			// formData.append('PrevimageURL', this.props.UserAuthentication?.UserInfo?.imageURL==null?"":this.props.UserAuthentication?.UserInfo?.imageURL);
			formData.append("accountNumber", $("#Profile_AccountNumber").val());

			var Parameters = {
				name: $("#Profile_Name").val(),
				contact: $("#Profile_Phone").val(),
				email: $("#Profile_Email").val(),
				address: $("#Profile_Address").val(),
				vehicleNumber: $("#Profile_VehicleNumber").val(),
				vehicleModel: $("#Profile_VehicleModel").val(),
				roleId: this.state.RoleId,
				imageURLBase64: this.state.isImageUpdated
					? imageURLBase64
					: this.props.UserAuthentication?.UserInfo?.imageURLBase64,
				accountNumber: $("#Profile_AccountNumber").val(),
			};
			Common.Ajax(
				this.props.UserAuthentication.AuthToken,
				"Post",
				false,
				Common.APILinks.UpdateUserProfile,
				JSON.stringify(Parameters),
				(resp) => {
					this.props.ShowLoader({ Isloading: false });
					if (resp.status) {
						$("#UploadImgBtn").val("");
						this.setState({
							isImageUpdated: false,
						});
						this.props.UpdateProfileChanges(resp.data);
						this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
						setTimeout(() => {
							$("#Alertmsgbtn").click();
						}, 50);
					} else {
						this.props.ShowAlert({ Type: 0, Msg: resp.message });
						setTimeout(() => {
							$("#Alertmsgbtn").click();
						}, 50);
					}
				},
				(error) => {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({
						Type: 0,
						Msg: "Something went wrong, please try again.",
					});
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			);
		});
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
